export const fadeInKeyframes = {
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
} as const;

export const FADE_IN_ANIMATION = '$fadeIn 500ms ease-in';

export const markdownColorInherit = {
  '& p, & span, & li, & h1, & h2, & h3, & code, & strong, & em': {
    color: 'inherit',
  },
} as const;
